import Card from './card';
import CardContent from './card-content';
var DefaultCard = Card;
DefaultCard.Content = CardContent;
export default DefaultCard;
//# sourceMappingURL=index.js.map